import {
    SET_ALL_APPLICATIONS,
    GET_APPLICANT_DETAILS,
    DELETE_APPLICATION
} from "../constants";

const initialState = {
    applicantData: {},
    allApplications: []
};
// const applicantData = {}

export const applicationReducer = (
    state = initialState,
    { type, payload }
) => {
    switch (type) {
        case SET_ALL_APPLICATIONS: {
            state = { ...state, allApplications: payload }
            return state;
        }
        case GET_APPLICANT_DETAILS: {
            state = { ...state, applicantData: payload }
            return state;
        }

        case DELETE_APPLICATION: {
            return state
        }

        default: {
            return state;
        }
    }
}